<template>
<div class="chapter">
<div class="inner_page">
<h1>Tabla de Contenido</h1>
<p><span href="#/c001" title="Link target outside of Sample">Título</span></p>
<p><span href="#/c002" title="Link target outside of Sample">Derechos de Autor</span></p>
<p><a href="#/c003">Los 11 mejores  entrenamientos de cardio, Para quemar grasa, tonificar y perder peso</a></p>
<p><span href="#/c004" title="Link target outside of Sample">Frecuencia Cardíaca Máxima = 208 - (0,7 x edad en años)</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?a74b2382